module.exports = __webpack_public_path__ + "static/media/payment-local.3e0a5ca3.png";